<template>
  <div
    class="offcanvas offcanvas-bottom bg-primary-grasient h-auto"
    tabindex="-1"
    id="AudioPlayerModulOffcanvas"
    aria-labelledby="AudioPlayerModulOffcanvasLabel"
    ref="AudioPlayerModulOffcanvas"
  >
    <div
      class="offcanvas-header d-flex align-items-center justify-content-between"
      style="padding-left: 48px; padding-right: 48px"
    >
      <div class="offcanvas-title h2">{{ $t("audio.player") }}</div>
      <div class="d-flex align-items-center">
        <!-- <button
          type="button"
          class="btn btn-link text-reset p-2 me-2 collapse-hover"
          id="collapse-player-btn"
          data-bs-dismiss="offcanvas"
          @click="$emit('collapse')"
        >
          <i class="bi bi-chevron-down fs-5"></i>
        </button> -->
        <button
          type="button"
          class="btn-close text-reset collapse-hover"
          data-bs-dismiss="offcanvas"
          @click="$emit('hide')"
        ></button>
      </div>
    </div>
    <div
      class="offcanvas-body text-white pb-5 pt-3"
      style="padding-left: 48px; padding-right: 48px"
    >
      <StandartAudioPlayerList />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Offcanvas } from "bootstrap";

import SongCardText from "./additionally/song-card-text.vue";
import FormatTime from "../app/_shared/format/format-time.vue";
import StandartHelpPanel from "@/components/app/headers/healps/standart-help-panel.vue";
import IconComponent from "../app/_shared/icons/icon-component.vue";
import StandartAudioPlayerList from "./standart-audio-player-list.vue";

@Options({
  components: {
    SongCardText,
    FormatTime,
    StandartHelpPanel,
    IconComponent,
    StandartAudioPlayerList,
  },
})
class AudioPlayerModul extends Vue {
  private offcanvasInstance: Offcanvas | null = null;

  get offcanvasElement(): HTMLDivElement {
    return this.$refs.AudioPlayerModulOffcanvas as HTMLDivElement;
  }

  mounted() {
    this.initializeOffcanvas();
  }

  beforeUnmount(): void {
    this.offcanvasInstance?.dispose();
  }

  private initializeOffcanvas() {
    if (this.offcanvasElement) {
      this.offcanvasInstance = new Offcanvas(this.offcanvasElement);
    }
  }

  public openAudioOffcanvas(): void {
    this.offcanvasInstance?.show();
  }

  public closeOffcanvas(): void {
    this.offcanvasInstance?.hide();
  }
}
export default AudioPlayerModul;
</script>

<style lang="scss" scoped></style>
